'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotParcoordsIcon = function PlotParcoordsIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M.875.25h.313c.5.125.875.5.875 1v4.938C6.251 5.125 10.501 4.063 14.688 3V1.25c0-.5.375-.875.813-1h.375c.438.125.875.5.875 1v2.188c4.375 1.688 8.813 3.313 13.188 4.938V1.251c0-.438.375-.875.875-1h.313c.438.125.75.438.875.813v29.875c-.125.375-.375.688-.75.813h-.563a1.07 1.07 0 0 1-.75-1v-3c-2.25-1.813-4.438-3.625-6.688-5.438a487.954 487.954 0 0 1-6.5 5.313v3.125c0 .438-.375.875-.75 1h-.563a1.07 1.07 0 0 1-.75-1v-2.75c-4.188-.813-8.438-1.563-12.625-2.375v5.125c0 .438-.375.875-.75 1H.75a1.18 1.18 0 0 1-.75-.875V1.127C.063.689.438.377.875.252M2.063 7.25v11.313c4.188-1.063 8.375-2.125 12.625-3.188V4.062A3664.18 3664.18 0 0 0 2.063 7.25M16.75 4.563v11.125a487.954 487.954 0 0 0 6.5 5.313c2.188-1.813 4.375-3.563 6.625-5.375 0 0 .063-.063.063-.125v-6c-4.375-1.625-8.813-3.313-13.188-4.938M2.063 19.625v4.938c4.188.813 8.375 1.563 12.625 2.375V16.5c-4.25 1-8.438 2.063-12.625 3.125m22.125 2c-.063 0-.063 0-.125.063 2 1.563 3.938 3.125 5.875 4.75v-9.5c-1.938 1.563-3.875 3.125-5.75 4.688m-7.438-4.563v9.188c1.875-1.5 3.75-3.063 5.688-4.563a366.502 366.502 0 0 0-5.688-4.625z' })
    );
};

exports.default = PlotParcoordsIcon;